module.exports = __webpack_public_path__ + "static/media/icone_128.78c766fb.png";